import { render } from "./parityHome.vue?vue&type=template&id=e8662c06&scoped=true"
import script from "./parityHome.vue?vue&type=script&lang=js"
export * from "./parityHome.vue?vue&type=script&lang=js"

import "../assets/css/game_parity.css?vue&type=style&index=0&id=e8662c06&scoped=true&lang=css"
import "./parityHome.vue?vue&type=style&index=1&id=e8662c06&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8662c06"]])

export default __exports__